import styles from './PaymentStatus.module.scss';
import Button from "../../../shared/components/UI/Button";
import LoaderSpinner from '../../../shared/components/Loaders/LoaderSpinner';
import { useGetOrderStatus } from '../../../entities/order/api/useGetOrderStatus';
import { displayNotImplemented } from '../../../shared/services/Notifications/NotificationServices';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router';

const formatDate = (isoString: string): string => {
    if (!isoString) return '';
    const date = new Date(isoString);
    const formattedDate = date.toLocaleDateString('ru-RU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });
    const formattedTime = date.toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
    });
    return `${formattedDate}, ${formattedTime}`;
};

const formatPrice = (price: string | number): string => {
    const num = Math.round(Number(price));
    if (isNaN(num)) return String(price);
    return num.toLocaleString('ru-RU');
};

const PaymentStatus = () => {
    // КОСТЫЛЬ: читаем payment_status из URL-параметров
    const { payment_id, payment_status: paymentStatusParam } = useParams<{
        payment_id: string;
        payment_status?: string;
    }>();

    // КОСТЫЛЬ: если в URL пришёл success/failed — не дергаем API и не рендерим детали
    const isShortCircuit =
        paymentStatusParam === 'success' || paymentStatusParam === 'failed';

    // Прокидываем undefined, чтобы useGetOrderStatus не ушёл в сеть
    const { data, isLoading, isFetching } = useGetOrderStatus(
        isShortCircuit ? undefined : payment_id
    );

    const isPendingStatus = data?.payment_status === 'pending' || data?.status === 'pending';

    // Спиннер показывается при первичной загрузке ИЛИ при фоновом обновлении, если статус всё ещё pending
    const showSpinner = !isShortCircuit && (isLoading || isPendingStatus);

    const navigate = useNavigate();

    const statusContent = {
        success: {
            icon: '/CheckoutOrder/success.svg',
            title: 'Оплата подтверждена',
            buttons: [
                {
                    text: 'Перейти к подпискам',
                    contrast: true,
                    onClick: () => {
                        navigate({
                            pathname: '/my-purchases',
                        });
                    }
                }
            ],
        },
        error: {
            icon: '/CheckoutOrder/error.svg',
            title: 'Оплата не прошла',
            buttons: [
                // {
                //     text: 'Попробовать снова',
                //     contrast: true,
                //     onClick: () => { displayNotImplemented() }
                // },
                {
                    text: 'Перейти в каталог',
                    contrast: false,
                    onClick: () => {
                        navigate({
                            pathname: '/my-purchases',
                            search: '?subscriptions_modal=packages'
                        });
                    }
                }
            ],
        },
        pending: {
            icon: '/CheckoutOrder/pending.svg',
            title: 'Платеж обрабатывается',
            buttons: [],
        },
    };

    // КОСТЫЛЬ: короткое замыкание — рендерим только иконку, заголовок и кнопки,
    // без детальной информации о заказе
    if (isShortCircuit) {
        const statusKey = paymentStatusParam === 'success' ? 'success' : 'error';
        const current = statusContent[statusKey];

        return (
            <section className={styles.paymentStatus}>
                <img
                    className={styles.paymentStatus__icon}
                    src={current.icon}
                    alt=""
                />

                <h2 className={styles.paymentStatus__title}>
                    {current.title}
                </h2>

                {current.buttons.length > 0 && (
                    <div className={styles.paymentStatus__buttons}>
                        {current.buttons.map((btn, index) => (
                            <Button
                                key={index}
                                contrastStyle={btn.contrast}
                                onClick={btn.onClick}
                            >
                                {btn.text}
                            </Button>
                        ))}
                    </div>
                )}
            </section>
        );
    }

    if (showSpinner) {
        return (
            <section className={styles.paymentStatus}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <LoaderSpinner contrastStyle />
                </div>
            </section>
        );
    }

    if (!data) {
        return null;
    }

    const status = data.payment_status === 'paid'
        ? 'success'
        : (data.payment_status === 'failed' || data.status === 'failed' ? 'error' : 'pending');

    const current = statusContent[status as keyof typeof statusContent] || statusContent.pending;
    const isError = status === 'error';

    const firstItem = data.items && data.items.length > 0 ? data.items[0] : null;

    return (
        <section className={styles.paymentStatus}>
            <img
                className={styles.paymentStatus__icon}
                src={current.icon}
                alt=""
            />

            <h2 className={styles.paymentStatus__title}>
                {current.title}
            </h2>

            <div className={styles.paymentStatus__info}>
                <div className={styles.paymentStatus__order}>
                    <div className={styles.paymentStatus__row}>
                        <span>Номер заказа</span>
                        <span>{data.order_number}</span>
                    </div>

                    <div className={styles.paymentStatus__row}>
                        <span>Дата и время</span>
                        <span>{formatDate(data.created_at)}</span>
                    </div>
                </div>

                <hr />

                <div className={styles.paymentStatus__pricing}>
                    <div className={styles.paymentStatus__row}>
                        <span>Стоимость подписки</span>
                        <span>{isError ? 'Не выполнено' : `${formatPrice(!!data.original_total ? data.original_total : data.total_sum)} ₽`}</span>
                    </div>
                </div>

                <hr />

                <div className={styles.paymentStatus__total}>
                    <div className={styles.paymentStatus__row}>
                        <span>Итог</span>
                        <span className={status === 'success' ? styles.success : ''}>
                            {isError ? 'Не выполнено' : `${formatPrice(data.final_total || data.total_sum)} ₽`}
                        </span>
                    </div>
                </div>
            </div>

            {current.buttons.length > 0 && (
                <div className={styles.paymentStatus__buttons}>
                    {current.buttons.map((btn, index) => (
                        <Button
                            key={index}
                            contrastStyle={btn.contrast}
                            onClick={btn.onClick}
                        >
                            {btn.text}
                        </Button>
                    ))}
                </div>
            )}
        </section>
    );
};

export default PaymentStatus;